document.addEventListener("DOMContentLoaded", function () {
  const canvas = document.getElementById("siteDrawCanvas");
  const toggleBtn = document.getElementById("toggleDrawBtn");
  const controls = document.getElementById("drawControls");
  const colorPicker = document.getElementById("drawColor");
  const brushBtn = document.getElementById("brushBtn");
  const eraserBtn = document.getElementById("eraserBtn");
  const clearBtn = document.getElementById("clearCanvasBtn");
  const saveBtn = document.getElementById("saveCanvasBtn");
  const brushShape = document.getElementById("brushShape");
  const brushPattern = document.getElementById("brushPattern");
  const brushSize = document.getElementById("brushSize");
  const sizeVal = document.getElementById("sizeVal");
  
  const brushOpacity = document.getElementById("brushOpacity");
  const opacityVal = document.getElementById("opacityVal");

  if (!canvas) return;
  const ctx = canvas.getContext("2d");

  let isDrawingActive = false;
  let isDrawing = false;
  let currentMode = "brush"; 
  let lastX = 0;
  let lastY = 0;

  let checkeredPattern;
  const pCanvas = document.createElement("canvas");
  pCanvas.width = 8;
  pCanvas.height = 8;
  const pCtx = pCanvas.getContext("2d");

  function updateCheckeredColor(color) {
    pCtx.clearRect(0, 0, 8, 8);
    pCtx.fillStyle = color;
    pCtx.fillRect(0, 0, 4, 4);
    pCtx.fillRect(4, 4, 4, 4);
    checkeredPattern = ctx.createPattern(pCanvas, "repeat");
  }

  function resizeCanvas() {
    const docHeight = Math.max(
      document.body.scrollHeight,
      document.documentElement.scrollHeight,
      document.body.offsetHeight,
      document.documentElement.offsetHeight
    );

    let tempCanvas;
    if (canvas.width > 0 && canvas.height > 0) {
      tempCanvas = document.createElement("canvas");
      tempCanvas.width = canvas.width;
      tempCanvas.height = canvas.height;
      tempCanvas.getContext("2d").drawImage(canvas, 0, 0);
    }

    canvas.width = window.innerWidth;
    canvas.height = docHeight;

    if (tempCanvas) {
      ctx.drawImage(tempCanvas, 0, 0);
    }
    updateCheckeredColor(colorPicker.value);
  }

  canvas.addEventListener("wheel", function (e) {
    if (isDrawing) return;
    window.scrollBy({
      top: e.deltaY,
      left: e.deltaX,
      behavior: "auto"
    });
  }, { passive: true });

  toggleBtn.addEventListener("click", () => {
    isDrawingActive = !isDrawingActive;
    if (isDrawingActive) {
      toggleBtn.textContent = "❌ Close Drawing";
      toggleBtn.classList.add("active-mode");
      canvas.classList.remove("hidden");
      controls.classList.remove("hidden");
      resizeCanvas();
    } else {
      toggleBtn.textContent = "🎨 Click here to draw";
      toggleBtn.classList.remove("active-mode");
      canvas.classList.add("hidden");
      controls.classList.add("hidden");
    }
  });

  saveBtn.addEventListener("click", function () {
    const imgData = ctx.getImageData(0, 0, canvas.width, canvas.height);
    const data = imgData.data;
    let minX = canvas.width, maxX = 0, minY = canvas.height, maxY = 0;
    let hasArtwork = false;

    for (let y = 0; y < canvas.height; y++) {
      for (let x = 0; x < canvas.width; x++) {
        const alphaIndex = (y * canvas.width + x) * 4 + 3;
        if (data[alphaIndex] > 0) { 
          hasArtwork = true;
          if (x < minX) minX = x;
          if (x > maxX) maxX = x;
          if (y < minY) minY = y;
          if (y > maxY) maxY = y;
        }
      }
    }

    if (!hasArtwork) {
      alert("Draw something on your screen first before exporting!");
      return;
    }

    const padding = 20;
    minX = Math.max(0, minX - padding);
    minY = Math.max(0, minY - padding);
    maxX = Math.min(canvas.width, maxX + padding);
    maxY = Math.min(canvas.height, maxY + padding);

    const croppedWidth = maxX - minX;
    const croppedHeight = maxY - minY;

    const exportCanvas = document.createElement("canvas");
    exportCanvas.width = croppedWidth;
    exportCanvas.height = croppedHeight;
    const exportCtx = exportCanvas.getContext("2d");

    exportCtx.drawImage(canvas, minX, minY, croppedWidth, croppedHeight, 0, 0, croppedWidth, croppedHeight);

    const dataURL = exportCanvas.toDataURL("image/png");
    const downloadLink = document.createElement("a");
    downloadLink.download = "my-store-artwork.png";
    downloadLink.href = dataURL;
    
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  });

  brushBtn.addEventListener("click", () => {
    currentMode = "brush";
    brushBtn.classList.add("active-tool");
    eraserBtn.classList.remove("active-tool");
  });

  eraserBtn.addEventListener("click", () => {
    currentMode = "erase";
    eraserBtn.classList.add("active-tool");
    brushBtn.classList.remove("active-tool");
  });

  clearBtn.addEventListener("click", () => {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
  });

  brushSize.addEventListener("input", (e) => {
    sizeVal.textContent = e.target.value + "px";
  });

  brushOpacity.addEventListener("input", (e) => {
    opacityVal.textContent = e.target.value + "%";
  });

  colorPicker.addEventListener("input", (e) => {
    updateCheckeredColor(e.target.value);
  });

  function getCanvasCoordinates(e) {
    if (e.touches && e.touches.length > 0) {
      return { 
        x: e.touches[0].pageX, 
        y: e.touches[0].pageY 
      };
    }
    return { x: e.pageX, y: e.pageY };
  }

  function hexToRgb(hex) {
    const cleanHex = hex.replace("#", "");
    return {
      r: parseInt(cleanHex.substring(0, 2), 16) || 0,
      g: parseInt(cleanHex.substring(2, 4), 16) || 0,
      b: parseInt(cleanHex.substring(4, 6), 16) || 0
    };
  }

  function handleStart(e) {
    isDrawing = true;
    const coords = getCanvasCoordinates(e);
    lastX = coords.x;
    lastY = coords.y;
  }

  function handleMove(e) {
    if (!isDrawing) return;
    const coords = getCanvasCoordinates(e);
    const bSize = parseInt(brushSize.value, 10);
    const bStyle = brushShape.value;
    const globalAlphaSetting = parseFloat(brushOpacity.value) / 100;

    ctx.lineWidth = bSize;
    ctx.globalAlpha = globalAlphaSetting;

    if (currentMode === "brush") {
      ctx.globalCompositeOperation = "source-over";

      // 🌟 NEON GLOW ENGINE: Automatically forces clean, unbroken solid brush parameters
      if (brushPattern.value === "neon") {
        ctx.setLineDash([]); 
        ctx.lineCap = "round"; 
        ctx.lineJoin = "round";
        ctx.shadowBlur = bSize * 1.5;
        ctx.shadowColor = colorPicker.value;
        ctx.strokeStyle = colorPicker.value;
        
        ctx.beginPath();
        ctx.moveTo(lastX, lastY);
        ctx.lineTo(coords.x, coords.y);
        ctx.stroke();

        ctx.shadowBlur = 0;
        ctx.strokeStyle = "#ffffff";
        ctx.lineWidth = bSize * 0.3;
        
        ctx.beginPath();
        ctx.moveTo(lastX, lastY);
        ctx.lineTo(coords.x, coords.y);
        ctx.stroke();
      } 
      else {
        ctx.shadowBlur = 0;
        ctx.shadowColor = "transparent";
        ctx.setLineDash([]);

        if (brushPattern.value === "checkered") {
          ctx.strokeStyle = checkeredPattern;
        } else {
          ctx.strokeStyle = colorPicker.value;
        }

        if (bStyle === "highlighter") {
          ctx.lineCap = "square";
          ctx.lineJoin = "miter";
          ctx.globalAlpha = globalAlphaSetting * 0.4;

          ctx.beginPath();
          ctx.moveTo(lastX, lastY);
          ctx.lineTo(coords.x, coords.y);
          ctx.stroke();
        } else if (bStyle === "spray") {
          const density = 40;
          ctx.fillStyle = colorPicker.value;
          for (let i = 0; i < density; i++) {
            const angle = Math.random() * Math.PI * 2;
            const radius = Math.random() * bSize * 1.5;
            const x = coords.x + Math.cos(angle) * radius;
            const y = coords.y + Math.sin(angle) * radius;
            ctx.fillRect(x, y, 1.5, 1.5);
          }
        } else if (bStyle === "sketchy") {
          ctx.lineCap = "round";
          ctx.lineJoin = "round";
          ctx.globalAlpha = globalAlphaSetting * 0.25;

          ctx.beginPath();
          ctx.moveTo(lastX, lastY);
          ctx.lineTo(coords.x, coords.y);
          ctx.stroke();

          const rgb = hexToRgb(colorPicker.value);
          ctx.strokeStyle = "rgba(" + rgb.r + "," + rgb.g + "," + rgb.b + "," + (globalAlphaSetting * 0.15) + ")";
          ctx.lineWidth = 1;

          ctx.beginPath();
          ctx.moveTo(lastX + (Math.random() - 0.5) * bSize, lastY + (Math.random() - 0.5) * bSize);
          ctx.lineTo(coords.x + (Math.random() - 0.5) * bSize, coords.y + (Math.random() - 0.5) * bSize);
          ctx.stroke();
        } else {
          ctx.lineCap = bStyle === "square" ? "square" : "round";
          ctx.beginPath();
          ctx.moveTo(lastX, lastY);
          ctx.lineTo(coords.x, coords.y);
          ctx.stroke();
        }
      }
    } else if (currentMode === "erase") {
      ctx.setLineDash([]);
      ctx.shadowBlur = 0;
      ctx.globalCompositeOperation = "destination-out";
      ctx.beginPath();
      ctx.moveTo(lastX, lastY);
      ctx.lineTo(coords.x, coords.y);
      ctx.stroke();
    }

    lastX = coords.x;
    lastY = coords.y;
  }

  function handleEnd() {
    isDrawing = false;
  }

  canvas.addEventListener("mousedown", handleStart);
  canvas.addEventListener("mousemove", handleMove);
  canvas.addEventListener("mouseup", handleEnd);
  canvas.addEventListener("mouseleave", handleEnd);

  canvas.addEventListener("touchstart", handleStart, { passive: true });
  canvas.addEventListener("touchmove", handleMove, { passive: true });
  canvas.addEventListener("touchend", handleEnd);

  window.addEventListener("resize", resizeCanvas);
  resizeCanvas();
});
